module.exports = __webpack_public_path__ + "static/media/29.197e4f1e.jpg";